module.exports = __webpack_public_path__ + "img/pagination-arrow.cc6a27a7.svg";